/**
 * @file コンポーネント：検索キーワード絞り込み スタイル管理
 */

// ライブラリ読み込み
import styled from "styled-components";

// スタイル
export const StyledForm = styled.form`
    display: flex;
    align-items: center;
    padding-right: 4px;
    overflow: hidden;
    border: 1px solid #808385;
    border-radius: 4px;
`;

export const StyledFormButton = styled.button`
    width: 32px;
    height: 32px;
    padding: 0;
    border: none;
    background-color: transparent;
    color: #acadae;
    font-size: 16px;
    line-height: 32px;
    text-align: center;
    outline: none;
    cursor: pointer;
`;

export const StyledFormInput = styled.input`
    width: calc(100% - 32px);
    margin-right: 4px;
    padding: 0 16px;
    border: none;
    background-color: transparent;
    color: #e3e3e4;
    font-size: 16px;
    line-height: 48px;

    &::placeholder {
        color: #acadae;
    }

    .is-ipad.is-safari &::placeholder,
    .is-iphone.is-safari &::placeholder {
        position: relative;
        top: -6px;
    }
`;
